<template>
    <div :class="theme.wrapper">
        <div v-show="filter.has_column_options" :class="theme.group">
            <div :class="theme.label">Date Field</div>
            <div :class="theme.field">
                <select
                    v-model="filter.current_column"
                    class="form-control form-control-sm"
                >
                    <option
                        v-for="(value, label) in filter.columns"
                        :key="`option-${label}`"
                        :value="value"
                        v-text="label"
                    />
                </select>
            </div>
        </div>

        <div v-if="isRange && filter['logic_enabled']" :class="theme.group">
            <div :class="theme.label">Logic</div>
            <div :class="theme.field">
                <select
                    v-model="filter.logic"
                    class="form-control form-control-sm"
                    :disabled="!hasFullRange"
                    @change="change"
                >
                    <option value="within">Within Range</option>
                    <option value="outside">Outside Range</option>
                </select>

                <i
                    v-popover.right="
                        `Specify both a start date and end date and then choose whether
                         you want matches within or outside that date range.`
                    "
                    class="icon-field-help-message"
                >
                </i>
            </div>
        </div>

        <div :class="theme.group">
            <div :class="theme.label">
                {{ isRange ? 'Start Date' : filter.label }}
            </div>
            <div :class="theme.field">
                <input
                    ref="startDate"
                    v-model="filter.current_value.startDate"
                    type="text"
                    class="form-control form-control-sm"
                />
            </div>
        </div>

        <div v-if="isRange" :class="theme.group">
            <div :class="theme.label">End Date</div>
            <div :class="theme.field">
                <input
                    ref="endDate"
                    v-model="filter.current_value.endDate"
                    type="text"
                    class="form-control form-control-sm"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Common from './mixins/Common.vue';

export default {
    mixins: [Common],
    props: {
        data: Object,
        filter: Object,
    },
    computed: {
        options() {
            return this.filter.options;
        },
        isRange() {
            return this.filter.is_range;
        },
        isActive() {
            return (
                !!this.filter.current_value.startDate ||
                !!this.filter.current_value.endDate
            );
        },
        hasFullRange() {
            return (
                !!this.filter.current_value.startDate &&
                !!this.filter.current_value.endDate
            );
        },
        displayLabel() {
            if (this.filter.has_column_options) {
                for (const i in this.filter.columns) {
                    if (this.filter.columns[i] === this.filter.current_column) {
                        return i;
                    }
                }
            }

            return this.filter.label;
        },
    },
    watch: {
        'filter.current_column': function () {
            this.change();
        },
    },
    mounted() {
        $(this.$el)
            .find('input')
            .datepicker({
                autoclose: true,
                orientation: 'bottom',
            })
            .change(() => {
                this.change();
            });
    },
    methods: {
        change() {
            this.filter.current_value = this.getCurrentValue();

            this.filter.display_data = [];

            if (!this.hasFullRange) {
                this.filter.logic = 'within';
            }

            let operator;
            if (this.filter.current_value.startDate) {
                if (this.isRange) {
                    if (this.filter.logic === 'within') {
                        operator = '>=';
                    } else if (this.filter.logic === 'outside') {
                        operator = '<';
                    }
                } else {
                    operator = '=';
                }

                this.filter.display_data.push({
                    key: 'start-date',
                    label: this.displayLabel,
                    operator,
                    value: this.filter.current_value.startDate,
                });
            }
            if (this.filter.current_value.endDate) {
                if (this.isRange) {
                    if (this.filter.logic === 'within') {
                        operator = '<=';
                    } else if (this.filter.logic === 'outside') {
                        operator = '>';
                    }
                } else {
                    operator = '=';
                }

                this.filter.display_data.push({
                    key: 'end-date',
                    label: this.displayLabel,
                    operator,
                    value: this.filter.current_value.endDate,
                    separator: this.filter.logic === 'outside' ? 'OR' : null,
                });
            }

            this.bus.$emit('filter-changed');
        },
        getCurrentValue() {
            return {
                startDate: $(this.$refs.startDate).val(),
                endDate: $(this.$refs.endDate).val(),
            };
        },
        getCurrentKey() {
            return this.filter.options.find(
                x => x.value === this.filter.current_value,
            ).key;
        },
    },
};
</script>

<style lang="scss" module></style>
<style
    lang="scss"
    module="theme_default"
    src="./../css/themes/default/date_filter.scss"
></style>
<style
    lang="scss"
    module="theme_simple"
    src="./../css/themes/simple/date_filter.scss"
></style>
